
import {Component, Vue, Watch} from 'vue-property-decorator';
import stores from '../../../stores';

@Component({
  components: {},
})

export default class DeleteDeviceType extends Vue {
  /**
   * Fired when this module is created
   */
  created() {
    this.delete();
  }

  delete() {
    return stores.Devices.deleteDeviceType(Number(this.$route.params.id))
      .then(() => {
        this.$router.push({name: 'devices.types'});
      })
      .catch((reason) => {
        console.error('Could not delete', reason);
      });
  }
}
